import { KYMW0A00Component } from './kymw0a00.component';
import { KYMW0D00InputModel } from '../../kymw0d/kymw0d00/vo/kymw0d00-input.model';
import { PlessViewUtilsSub } from '../../kymw00/pless-view-utils-sub.service';

/**
 * 組合員の声管理画面の値を管理するクラス
 *
 * @export KYMW0A00Model
 * @class KYMW0A00Model
 */
export class KYMW0A00Model {

  public kymw0A00Component: KYMW0A00Component;

  // 【選択Ｐコードエリア】
  /**
   * 選択Ｐコードリスト
   */
  public pcodeList: Array<any> = null;

  /** 選択Ｐコード */
  public pcodeListSelectedValue: string = <string>'';

  /**
   * 商品案内用商品名
   */
  public guideGoodsName: string = <string>'';

  /**
   * 商品案内用規格名
   */
  public guideStandardName: string = <string>'';

  // 【組合員の声一覧エリア】
  /**
   * 総件数
   */
  public totalNum: number = <number>0;

  /**
   * 開始件数
   */
  public startDispNum: number = <number>0;

  /**
   * 終了件数
   */
  public endDispNum: number = <number>0;

  /**
   * 組合員の声一覧
   */
  public membersVoiceArray: Array<any> = null;

  // 【組合員の声詳細情報エリア】
  /**
   * 受付番号
   */
  public receiptNum: string = <string>'';

  /**
   * 生協名
   */
  public coopName: string = <string>'';

  /**
   * Ｐコード
   */
  public pcode: string = <string>'';

  /**
   * 組合員名（漢字）
   */
  public memberName: string = <string>'';

  /**
   * 匿名希望者
   */
  public anonymous: string = <string>'';

  /**
   * 部門
   */
  public className: string = <string>'';

  /**
   * 商品名
   */
  public subject: string = <string>'';

  /**
   * 問合せ内容
   */
  public inquiryContents: string = <string>'';

  /**
   * 会員受付日
   */
    public receiptDate: string = <string>'';

  // 【誌面掲載用項目エリア】
  /**
   * 組合員名（漢字）
   */
  public correctMemberName: string = <string>'';

  /**
   * 匿名希望者
   */
  public correctAnonymous: string = <string>'';

  /**
   * 使用名称
   */
  public correctCenterCoopDiv: string = <string>'1';


  /**
   * センター名
   */
  public correctCenterName: string = <string>'';

  /**
   * 問合せ内容
   */
  public correctInquiryContents: string = <string>'';


  // 【誌面掲載用項目エリア】初期値保存用
  /**
   * 組合員名（漢字）初期値保存用
   */
  public defaultMemberName: string = <string>'';

  /**
   * 匿名希望者　初期値保存用
   */
  public defaultAnonymous: string = <string>'';

  /**
   * 使用名称 初期値保存用
   */
  public defaultCenterCoopDiv: string = <string>'1';


  /**
   * センター名 初期値保存用
   */
  public defaultCenterName: string = <string>'';

  /**
   * 問合せ内容 初期値保存用
   */
  public defaultInquiryContents: string = <string>'';


  // 【内部変数エリア】
  /**
   * 選択Ｐコード受付番号
   */
  public selectReceiptNum: string = <string>'';

  /**
   * 組合員の声掲載履歴存在フラグ
   */
  public publishVoiceExistFlg: string = <string>'';

  /**
   * ＮＧワード
   */
  public ngWord: string = <string>'';

  /**
   * 画面タイトル
   */
  public title: string = <string>'';

  /**
   * 処理ログ登録用VO
   */
  public kYMW0D00InputVO: KYMW0D00InputModel = null;

  /** スクロールの位置を保持 */
  public verticalScrollPosition: number = <number>0;

  /** 前へボタン */
  // public btnBackEnabled: boolean = <boolean>true;

  /** 次へボタン */
  // public btnNextEnabled: boolean = <boolean>true;

  /** ページ番号 */
  public pageNo: number = <number>1;

  /** ソートキー */
  public sortKey: string = <string>'';

  /** 降順または昇順 */
  public orderKey: string = <string>'';

  /** 活性・非活性設定 */
  // public txtiCorrectMemberNameEnabled = true;
  // public txtiCorrectAnonymousEnabled = true;
  // public rdbgCenterEnabled = true;
  // public rdbgCoopEnabled = true;
  // public txtiCenterNameEnabled = true;
  // public txtiCorrectInquiryContentsEnabled = true;
  // public btnSelectEnabled = true;
  // public btnUpdateEnabled = false;

  /** 表示・非表示設定 */
  public btnUpdateVisible = '';
  public lblPcodeListLblVisible = '';
  public cmbPcodeListVisible = '';
  public lblGuideGoodsNameLblVisible = '';
  public lblGuideGoodsNameVisible = '';
  public lblGuideStandardNameLblVisible = '';
  public lblGuideStandardNameVisible = '';
  public btnSelectVisible = '';

  // 組合員の声取込表示有効無効
  public uploadMembersVoiceDataEnabled: boolean = true;

  /**
   * サーバからの受信データにてＰコードリスト情報を更新する
   *
   * @param serverData サーバからの受信データ
   */
  public getPcodeList(serverData: any): void {
    const wpcodeList: Array<any> = serverData;
    const wpcodeArray: Array<any> = new Array<any>();

    // 選択Ｐコード
    wpcodeList.forEach ((item) => {
      const ob = {
        Pcode: item.PcodeList,
        GuideGoodsName: PlessViewUtilsSub.nullToBlank(item.GuideGoodsName),
        GuideStandardName: PlessViewUtilsSub.nullToBlank(item.GuideStandardName),
        Caption: item.PcodeList,
      };
      wpcodeArray.push(ob);
    });

    this.pcodeList =  wpcodeArray;
    this.pcodeListSelectedValue = this.pcodeList[0].Pcode;
    this.guideGoodsName = this.pcodeList[0].GuideGoodsName;
    this.guideStandardName = this.pcodeList[0].GuideStandardName;
    if (this.kymw0A00Component._initFlagGetPCodeList === true) {
      this.kymw0A00Component._initFlagGetPCodeList = false;
    }
  }

  /**
   * サーバからの受信データにて組合員の声一覧情報を更新する
   *
   * @param serverData サーバからの受信データ
   */
  public getMembersVoicePcodeList(serverData: any): void {
    // 組合員の声一覧検索結果をview項目に設定する
    this.setMembersVoiceList(serverData);
  }

  /**
   * サーバからの受信データにて組合員の声一覧情報を更新する
   *
   * @param serverData サーバからの受信データ
   */
  public getMembersVoiceSearchList(serverData: any): void {
    // 組合員の声一覧検索結果をview項目に設定する
    this.setMembersVoiceList(serverData);
  }

  /**
   * サーバからの受信データにて組合員の声管理情報を更新する
   *
   * @param serverData サーバからの受信データ
   */
  public getMembersVoiceData(serverData: any): void {
    // 【組合員の声詳細情報エリア】
    this.receiptNum = serverData.ReceiptNum;
    this.coopName = serverData.CoopName;
    this.pcode = serverData.Pcode;
    this.memberName = serverData.MemberName;
    this.anonymous = serverData.Anonymous;
    this.className = serverData.ClassName;
    this.subject = serverData.Subject;
    this.inquiryContents = serverData.InquiryContents;
    this.receiptDate = serverData.ReceiptDate;
    // 【誌面掲載用項目エリア】
    this.correctMemberName = serverData.CorrectMemberName;
    this.correctAnonymous = serverData.CorrectAnonymous;
    this.correctCenterCoopDiv = serverData.CenterCoopDiv;
    this.correctCenterName = serverData.CenterName;
    this.correctInquiryContents = serverData.CorrectInquiryContents;

    // 初期値保存用（組合員の声詳細情報エリアに情報がないため）
    this.defaultMemberName = serverData.CorrectMemberName;
    this.defaultAnonymous = serverData.CorrectAnonymous;
    this.defaultCenterCoopDiv = serverData.CenterCoopDiv;
    this.defaultCenterName = serverData.CenterName;
    this.defaultInquiryContents = serverData.CorrectInquiryContents;

    if (this.kymw0A00Component._initFlagGetMembersVoiceData === true) {
      this.kymw0A00Component._initFlagGetMembersVoiceData = false;
    }
  }

  /**
   * サーバからの受信データにて選択Ｐコードに紐付く受付番号を更新する
   *
   * @param serverData サーバからの受信データ
   */
  public getPublishVoiceData(serverData: any): void {
    // 選択Ｐコードに紐付く受付番号をview項目に設定する
    this.selectReceiptNum = serverData.ReceiptNum;
  }

  /**
   * サーバからの受信データにて組合員の声掲載履歴存在フラグを更新する
   *
   * @param serverData サーバからの受信データ
   */
  public getPublishVoiceHistory(serverData: any): void {
    // 組合員の声掲載履歴存在フラグをview項目に設定する
    this.publishVoiceExistFlg = serverData.PublishHistoryFlag;
  }

  /**
   * サーバからの受信データにてＮＧワードを更新する
   *
   * @param serverData サーバからの受信データ
   */
  public checkNgWords(serverData: any): void {
    // ＮＧワードをview項目に設定する
    this.ngWord = PlessViewUtilsSub.nullToBlank(serverData.Result);
    if (this.kymw0A00Component._initFlagCheckNgWords === true) {
      this.kymw0A00Component._initFlagCheckNgWords = false;
    }
  }

  /**
   * 処理ログ登録用VOをview項目に設定する
   */
  public uploadMembersVoiceData(serverData: any): void {
    // 処理ログ登録用VOをview項目に設定する
    const inputVo: KYMW0D00InputModel = new KYMW0D00InputModel();
    // 画面ＩＤ
    inputVo.dispId = 'KYMW0A00';
    // 正常件数
    inputVo.normalNum = serverData.NormalNum;
    // 注意件数
    inputVo.attentionNum = serverData.AttentionNum;
    // 異常件数
    inputVo.abnormalNum = serverData.AbnormalNum;
    // ＤＢ更新件数
    inputVo.updateNum = serverData.UpdateNum;
    // 処理件数
    inputVo.manageNum = serverData.ManageNum;
    this.kYMW0D00InputVO = inputVo;
  }

  /**
   * 組合員の声一覧検索結果をview項目に設定する
   */
  private setMembersVoiceList(serverData: any): void {
    if (serverData.MembersVoice == null) {
      this.kymw0A00Component._initFlagSetMembersVoiceList = false;
      return;
    }

    // 取得件数の設定
    this.totalNum = Number(serverData.TotalNum);
    this.startDispNum = Number(serverData.RownumFrom);
    this.endDispNum = Number(serverData.RownumTo);

    // 組合員の声一覧データの作成
    this.membersVoiceArray = serverData.MembersVoice;
    if (this.kymw0A00Component._initFlagSetMembersVoiceList === true) {
      this.kymw0A00Component._initFlagSetMembersVoiceList = false;
    }

    // 受付番号の不要な半角スペースをトリム
    for (let i = Number(0); i < this.membersVoiceArray.length; i++) {
      this.membersVoiceArray[i].ReceiptNum = PlessViewUtilsSub.trim(this.membersVoiceArray[i].ReceiptNum);
    }
  }
}
